import React from 'react';

import { Form } from 'antd';
import { FaEnvelope, FaShieldAlt } from 'react-icons/fa';

import { FormInput } from '@src/components/atoms/form/form-input';
import { TextLink } from '@src/components/atoms/text-link';
import { FacebookSignIn } from '@src/components/molecules/facebook/facebook-sign-in';
import { GoogleSignIn } from '@src/components/molecules/google/google-sign-in';
import { GradientButton } from '@src/components/molecules/gradient-button';
import { useNotificationContext } from '@src/components/molecules/notification-context';
import { TwitterSignIn } from '@src/components/molecules/twitter/twitter-sign-in';
import { NOTIFICATION_TYPES } from '@src/utils/constants';

import { StyledLoginForm } from './styles';
import { bemClassName } from '../../../../utils/bem';

const b = bemClassName('login-form');

const LoginForm = ({ onSignIn, onGoogleSignIn, onFacebookSignIn, onTwitterSignIn, onSwitchTo, loading }) => {
  const [form] = Form.useForm();
  const notificationApi = useNotificationContext();

  const handleGoogleFailure = () => {
    notificationApi[NOTIFICATION_TYPES.error]({
      message: 'Google sign in failed. Please try again.',
      pauseOnHover: true,
    });
  };

  const handleFacebookFailure = (errorData) => {
    console.error('[LoginForm] Facebook login error:', errorData);
    notificationApi[NOTIFICATION_TYPES.error]({
      message: errorData?.error || 'Facebook sign in failed. Please try again.',
      pauseOnHover: true,
    });
  };

  return (
    <StyledLoginForm>
      <Form
        className={b()}
        form={form}
        layout="vertical"
        onFinish={onSignIn}
        initialValues={{
          email: '',
          password: '',
        }}
      >
        <div className={b('item')}>
          <FormInput
            name="email"
            label="Email"
            rules={[
              { required: true, message: 'Please input your email!' },
              { type: 'email', message: 'The input is not valid E-mail!' },
            ]}
            icon={<FaEnvelope />}
            form={form}
          />
        </div>
        <div className={b('item')}>
          <FormInput
            name="password"
            label="Password"
            rules={[{ required: true, message: 'Please input your password!' }]}
            icon={<FaShieldAlt />}
            isPassword
            form={form}
          />
        </div>

        <div className={b('item')}>
          <TextLink onClick={() => onSwitchTo('forgot')}>Forgot password?</TextLink>
        </div>

        <div className={b('submit')}>
          <Form.Item>
            <GradientButton type={loading ? 'button' : 'submit'} loading={loading} width="auto">
              CONTINUE
            </GradientButton>
          </Form.Item>
        </div>

        <div className={b('social')}>
          <div className={b('divider')}>
            <span className={b('divider-line')} />
            <span className={b('divider-text')}>or</span>
            <span className={b('divider-line')} />
          </div>
          <div className={b('social-buttons')}>
            <GoogleSignIn onSuccess={onGoogleSignIn} onError={handleGoogleFailure} variant="icon" />
            <FacebookSignIn onSuccess={onFacebookSignIn} onError={handleFacebookFailure} variant="icon" />
            <TwitterSignIn onSignIn={onTwitterSignIn} variant="icon" />
          </div>
        </div>
      </Form>
    </StyledLoginForm>
  );
};

export default LoginForm;
